import { useContext } from 'react';
import * as React from 'react';

export const ActiveQueueContext = React.createContext({});
export const ActiveQueueProvider = ActiveQueueContext.Provider;
export const ActiveQueueConsumer = ActiveQueueContext.Consumer;

ActiveQueueContext.displayName = 'ActiveQueueContext';

export const useActiveQueue = () => useContext(ActiveQueueContext);